import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import {
  ParametrosOrdenamientosEntity,
  ServicioOrdenamientosService,
  FiltrosOrdenMedicamentosEntity,
  OrdenMedicamentoEntity,
  InfoOrdenamientoEntity
} from 'src/app/services/servicio-ordenamientos.service';
import { ActivatedRoute } from '@angular/router';
import { ServicioEntidadService, EntidadEmpresarialEntity, } from 'src/app/services/servicio-entidad.service';
import { ImagesService } from 'src/app/services/utils/images.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-reporte-orden-medicamentos',
  templateUrl: './reporte-orden-medicamentos.component.html',
  styleUrls: ['./reporte-orden-medicamentos.component.css']
})
export class ReporteOrdenMedicamentosComponent implements OnInit {

  filtros: FiltrosOrdenMedicamentosEntity;
  parametros: ParametrosOrdenamientosEntity = {} as ParametrosOrdenamientosEntity;
  ordenesAgrupadas: OrdenMedicamentoEntity[][] = [[]];
  entidadEmpresarial: EntidadEmpresarialEntity;
  infoOrdenamiento: InfoOrdenamientoEntity;

  now = new Date();
  validoHasta: any;
  mensajeLoading: string = 'Cargando...';
  mensajeError: string;
  logo: string;

  constructor(private activatedRoute: ActivatedRoute,
    private ordenamientosService: ServicioOrdenamientosService,
    private servicioEntidad: ServicioEntidadService,
    private servicioImagenes: ImagesService,
  ) {
    this.activatedRoute.params.subscribe(params => {
      this.parametros.codigo = params['codigoBaseDatos'];
      this.parametros.uncoSede = Number(params['uncoSede']);
      this.parametros.uncoLogin = Number(params['uncoLogin']);
      this.parametros.unco = Number(params['uncoAdmision']);
      this.parametros.uncoTransaccion = Number(params['uncoTransaccion']);
      this.parametros.uncoHc = Number(params['uncoHc']);
    });
  }

  ngOnInit() {
    this.getLogo();
  }

  onFiltrosCompletados(filtros: FiltrosOrdenMedicamentosEntity) {
    this.filtros = filtros;
    this.getOrdenesMedicamentos();
  }

  async getLogo() {
    try {
      this.logo = '';
      this.mensajeLoading = 'Cargando información del logo entidad ...';
      const response = await this.servicioImagenes.getLogo(this.parametros.codigo);
      response.subscribe((data: any) => {
        this.logo = data.source;
        this.getEntidadEmpresarial();
      }, (err: HttpErrorResponse) => {
        console.error('Error ReporteOrdenMedicamentosComponent.getLogo()', err);
        this.onError('Error al obtener información del logo entidad, verifique su conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
      });
    } catch (e) {
      console.error('Catch ReporteOrdenMedicamentosComponent.getLogo()', e);
      this.onError('Error grave al obtener información del logo entidad, intente de nuevo o reporte caso al administrador.');
    }
  }

  async getEntidadEmpresarial() {
    try {
      this.mensajeLoading = 'Cargando información entidad empresarial ...';
      const response = await this.servicioEntidad.getEntidadEmpresarial(this.parametros.codigo, this.parametros.uncoSede);
      response.subscribe((data: EntidadEmpresarialEntity[]) => {
        if (data && data.length > 0) {
          this.entidadEmpresarial = data[0];
          this.mensajeLoading = null;
          this.mensajeError = null;
        } else {
          this.onError('No se pudo cargar la información de la entidad empresarial. Por favor verifique los filtros.');
        }
      }, (err: HttpErrorResponse) => {
        console.error('Error ReporteOrdenMedicamentosComponent.getEntidadEmpresarial()', err);
        this.onError('Error al obtener información de la entidad empresarial, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
      });
    } catch (e) {
      console.error('Catch ReporteOrdenMedicamentosComponent.getEntidadEmpresarial()', e);
      this.onError('Error grave al obtener información de la entidad empresarial, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
    }
  }

  async getOrdenesMedicamentos() {
    try {
      this.mensajeLoading = 'Cargando ordenes de medicamentos ...';
      const response = await this.ordenamientosService.getOrdenesMedicamentos(this.parametros, this.filtros);
      response.subscribe((data: any) => {
        if (data && data['#result-set-1'].length > 0) {
          const ordenes = this.ordenamientosService.getOrdenesMedicamentoEntity(data['#result-set-1']);
          const { discriminarTipo, impresionMedicamentos } = this.filtros;
          this.ordenesAgrupadas = ordenes.reduce((prev, current) => {
            for (let index = 0; index < prev.length; index++) {
              const first = prev[index][0];
              if (impresionMedicamentos) {
                if (first['uncoMedicamento'] === current['uncoMedicamento']) {
                  prev[index].push(current);
                  return prev;
                }
              } else if (discriminarTipo) {
                if (first['tipoMedicamento'] === current['tipoMedicamento']) {
                  prev[index].push(current);
                  return prev;
                }
              } else {
                prev[0].push(current);
                return prev;
              }
            }
            prev.push([current]);
            return prev;
          }, []);

          this.getInfoAdicionalOrdenamiento();
        } else {
          this.onError('No se pudo cargar la información de las ordenes de medicamentos. Por favor verifique los filtros.');
        }
      }, (err: HttpErrorResponse) => {
        console.error('Error ReporteOrdenMedicamentosComponent.getOrdenesMedicamentos()', err);
        this.onError('Error al obtener información de las ordenes de medicamentos, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
      });
    } catch (e) {
      console.error('Catch ReporteOrdenMedicamentosComponent.getOrdenesMedicamentos()', e);
      this.onError('Error grave al obtener información de las ordenes de medicamentos, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
    }
  }

  async getInfoAdicionalOrdenamiento() {
    try {
      const response = await this.ordenamientosService.getInfoAdicionalOrdenamiento(this.parametros,
        this.filtros.profesionales[0]);

      response.subscribe((data: any) => {
        if (data && data['diasValidez']) {
          this.infoOrdenamiento = this.ordenamientosService.getInfoOrdenamientoEntity(data);
          this.validoHasta = moment(this.filtros.fechaInicio, 'YYYY-MM-DD')
            .add(this.infoOrdenamiento.diasValidez, 'days');

          this.mensajeLoading = null;
          this.mensajeError = null;
        } else {
          this.onError('No se pudo cargar la información de la orden de medicamento. Por favor verifique los filtros.');
        }
      }, (err: HttpErrorResponse) => {
        console.error('Error ReporteOrdenMedicamentosComponent.getInfoAdicionalOrdenamiento()', err);
        this.onError('Error al obtener información de la orden de medicamento, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
      });
    } catch (e) {
      console.error('Catch ReporteOrdenMedicamentosComponent.getInfoAdicionalOrdenamiento()', e);
      this.onError('Error grave al obtener información de la orden de medicamento, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
    }
  }

  getDescripcionDiagnostico(key: 'diagnostico' | 'diagnosticoRel1' | 'diagnosticoRel2') {
    let descripcionDiagn = '--';
    if (this.infoOrdenamiento && this.infoOrdenamiento[key]) {
      const { descripcion, codigoDiagnostico, activaDescripcion } = this.infoOrdenamiento[key];
      if (activaDescripcion) {
        descripcionDiagn = `(${codigoDiagnostico}) ${descripcion}`;
      } else {
        if (codigoDiagnostico !== undefined && codigoDiagnostico.trim().length > 0) {
          descripcionDiagn = `(${codigoDiagnostico})`
        }
      }
    }
    return descripcionDiagn;
  }

  onMensajeCarga(mensaje: string) {
    this.mensajeLoading = mensaje;
  }

  onErrorGenerado(mensajeError: string) {
    this.mensajeError = mensajeError;
  }

  onError(msj) {
    this.mensajeLoading = null;
    this.mensajeError = msj;
  }

  isLoading(): boolean {
    return this.mensajeLoading && this.mensajeLoading.length > 0
      && !this.isError();
  }

  isError(): boolean {
    return this.mensajeError && this.mensajeError.length > 0;
  }

  isReady(): boolean {
    return !this.isLoading() && !this.isError();
  }

}
